(function() {

  'use strict';

  angular.module('eclipseApp.myAccount').controller('downloadBillingOption', ['$scope', '$http', 'uteEndpoint', 'uteModal', 'data', '$filter', 'dtmService', 'dtmServiceConstants', 'dataLayerService', function($scope, $http, uteEndpoint, uteModal, data, $filter, dtmService, dtmServiceConstants, dataLayerService) {
    $scope.documentId = data.documentId;
    $scope.accountNumber = data.accountNumber;
    $scope.content_id = data.content_id;

    $scope.documentIdArray = data.documentIdAll;
    $scope.issueDateAll = data.issueDateAll;
    $scope.bbInvoiceLinkAndDate = data.bbInvoiceLinkAndDate;

    $scope.screen = 'downloadOptions';
    $scope.issue_date = data.issue_date;
    var billCycle = $filter('date')($scope.issue_date, 'MMMdd_yyyy')
    $scope.androidBrowser = false;
    var ua = navigator.userAgent.toLowerCase();
    var isAndroid = ua.indexOf("android") > -1; //&& ua.indexOf("mobile");
    if(isAndroid) {
    	$scope.androidBrowser = true;
    }

    $scope.printBBPdf = function() {
      dtmService.setVar(dtmServiceConstants.dtmRules.dtmDownloadBill.billType.parameterName, dtmServiceConstants.dtmRules.dtmDownloadBill.billType.print);
      dtmService.direct(dtmServiceConstants.dtmRules.dtmDownloadBill.ruleName);
      uteModal.open({
        controller: 'printInvoiceCtrl',
        templateUrl: 'modules/my-account/view-invoice/printInvoice.html',
        data :{
          'documentId' : $scope.documentId,
          'accountNumber' : $scope.accountNumber
        },
        size:'lg',
        backdrop: 'static',
        keyboard: false,
        ok: function () {
          console.log('OK');
        },
        cancel: function () {
          console.log('CANCEL');
        }
      });
    };
    var tokenNumberForDownloadBill = '';
    $scope.saveBBPdf = function() {
      dtmService.setVar(dtmServiceConstants.dtmRules.dtmDownloadBill.billType.parameterName, dtmServiceConstants.dtmRules.dtmDownloadBill.billType.pdf);
      dtmService.direct(dtmServiceConstants.dtmRules.dtmDownloadBill.ruleName);
      // try{
      // var  page = dtmServiceConstants.dataLayerTrack.page.saveMultipleBill;
      // var AnalyticsDataLayer = {
      //     'page': page,
      //     'interaction': {
      //       'type': 'click',
      //       'name': 'myaccount save copy of bill pdf'
      //     },
      //     'events': {
      //       'interaction': true
      //     }
      //   };
      //   dataLayerService.trackDataLayer(AnalyticsDataLayer, true, dtmServiceConstants.dataLayerTrack.basicPayloadInfo);
      // }
      // catch(e){
      //   console.log("Exception occured while tracking data layer on click of Save Bills as PDF -->" + e);
      // }
      uteModal.open({
        controller: 'saveBillPdfCtrl',
        templateUrl: 'modules/my-account/view-invoice/saveBillPdf.html',
        data: {
          'selectedDocumentId': $scope.documentId,
          'accountNumber' : $scope.accountNumber,
          'selectedIssueDate': $scope.issue_date,
          'listDocumentId': $scope.documentIdArray,
          'listIssueDate': $scope.issueDateAll,
          'bbInvoiceLinkAndDate': $scope.bbInvoiceLinkAndDate
        },
        windowTemplateUrl: 'views/templates/modal/pop-up-window-modal.html',
        windowClass: 'save-print-bill-modal-specific',
        backdrop: 'static',
        size: 'sm',
        ok: function () {
          console.log('OK');
        },
        cancel: function () {
          console.log('CANCEL');
        }
      });
      /*$scope.screen = 'loading';
      $http({
        method: 'POST',
        url: uteEndpoint('olb/retrieveBBToken'),
        data: {
          accountNumber: $scope.accountNumber
        }
      }).success(function(tokenNumber) {
        if (tokenNumber){
          tokenNumberForDownloadBill = tokenNumber.token;
          var xhr = new XMLHttpRequest();
          xhr.onreadystatechange = function() {
            if(xhr.readyState == 4 && xhr.status == 200) {
              window.location.href = "rogers_rest/rogers/" + $scope.documentId + ".pdf?EncryptedToken=" + encodeURIComponent(tokenNumberForDownloadBill);
              $scope.screen = 'downloadSuccess';
              $scope.pdfSuccess = true;
            }
            else if (xhr.status == 500 || xhr.status == 404) {
              $scope.screen = 'error';
            }
          }
          xhr.open('head',"rogers_rest/rogers/" + $scope.documentId + ".pdf?EncryptedToken=" + encodeURIComponent(tokenNumberForDownloadBill));
          xhr.send(null);
        }
      });*/
    }

    var tokenForDownloadOtherFormat = '';
    $scope.downloadOtherFormat = function(format) {
      $scope.screen = 'loading';
      $scope.headerFormat = 'application/vnd.ms-excel';
      if (format === 'csv') {
        $scope.headerFormat = 'text/csv';
        dtmService.setVar(dtmServiceConstants.dtmRules.dtmDownloadBill.billType.parameterName, dtmServiceConstants.dtmRules.dtmDownloadBill.billType.csv);
        dtmService.direct(dtmServiceConstants.dtmRules.dtmDownloadBill.ruleName);
      }else if(format === 'xls'){
        dtmService.setVar(dtmServiceConstants.dtmRules.dtmDownloadBill.billType.parameterName, dtmServiceConstants.dtmRules.dtmDownloadBill.billType.excel);
        dtmService.direct(dtmServiceConstants.dtmRules.dtmDownloadBill.ruleName);
      }
      $http({
        method: 'POST',
        url: uteEndpoint('olb/retrieveBBToken'),
        data: {
          accountNumber: $scope.accountNumber
        }
      }).success(function(tokenNumber) {
        if (tokenNumber){
          tokenForDownloadOtherFormat = tokenNumber.token;
          $http({
            method: 'GET',
            headers: {
              'Accept': $scope.headerFormat
            },
            url: 'rogers_rest/rogers/document/' + $scope.content_id + '/usage/details/Fido-' + billCycle + "-" + $scope.accountNumber + "-Usage/?download=false&EncryptedToken=" + encodeURIComponent(tokenForDownloadOtherFormat),
            responseType: 'arraybuffer'
          }).success(function(result, status, headers, config){
            var file = new Blob([result], {type: $scope.headerFormat});
            var filename = 'Fido-' + billCycle + '-' + $scope.accountNumber + '-Usage.'+format;
            if (window.navigator.msSaveOrOpenBlob) { // IE10+
              window.navigator.msSaveOrOpenBlob(file, filename);
              if ($scope.headerFormat === 'application/vnd.ms-excel') {
                $scope.screen = 'downloadSuccess';
                $scope.excelSuccess = true;
                $scope.csvSuccess = false;
              }
              else if ($scope.headerFormat === 'text/csv') {
                $scope.screen = 'downloadSuccess';
                $scope.excelSuccess = false;
                $scope.csvSuccess = true;
              }
            }
            else {
              var a = $('<a style="display: none;"/>');
              var url = URL.createObjectURL(file);
              a.attr('href', url);
              a.attr('download', filename);
              $('body').append(a);
              a[0].click();
              setTimeout(function() {window.URL.revokeObjectURL(url);},200); // Added time out for firefox, as it removes the link before invoking
              if ($scope.headerFormat === 'application/vnd.ms-excel') {
                $scope.screen = 'downloadSuccess';
                $scope.excelSuccess = true;
                $scope.csvSuccess = false;
              }
              else if ($scope.headerFormat === 'text/csv') {
                $scope.screen = 'downloadSuccess';
                $scope.excelSuccess = false;
                $scope.csvSuccess = true;
              }
            }
          }).error(function(data ,status){
            if (status === 417) {
              $scope.screen = 'noUsage';
              $scope.csvSuccess = false;
              $scope.excelSuccess = false;
            }
            else if (status === 401 || status === 409 || status === 410 || status === 412) {
              $scope.screen = 'error';
              $scope.csvSuccess = false;
              $scope.excelSuccess = false;
            }
            else {
              $scope.screen = 'error';
              $scope.csvSuccess = false;
              $scope.excelSuccess = false;
            }
          })
        }
      }).error(function(data){
        $scope.screen = 'error';
        $scope.csvSuccess = false;
        $scope.excelSuccess = false;
      });
    }

  }]);

})();
